import { Quote } from "lucide-react";
import React from "react";

const StudentTestimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Sarah",
      school: "Havard University",
      content:
        "W2ST made finding a tutor effortless. I connected with a fantastic in-person tutor, and my grades skyrocketed!",
    },
    {
      id: 2,
      name: "Zaire",
      school: "James",
      content:
        "W2ST matched me with a perfect online tutor. The convenience and quality of instruction were exceptional.",
    },
    {
      id: 3,
      name: "Emily",
      school: "Havard University",
      content:
        "I was hesitant, but W2ST exceeded my expectations. The platform and tutors made learning enjoyable and effective.",
    },
  ];

  const TestAvatar2 = require("../../../assets/images/avatar2.webp");

  return (
    <section className="py-20 bg-gradient-to-b from-white to-[#E2DDFF]">
      <p className="text-center uppercase text-gray500 mb-[24px]">
        TESTIMONIALS
      </p>
      <center className="text-txs md:text-dmd text-gray-700 mb-[52px] W2STMedium">
        What other students say
        <br /> about us
      </center>
      <div className="container mx-auto grid md:grid-cols-3 grid-cols-1 gap-4">
        {testimonials.map(({ id, name, school, content }) => (
          <div
            key={id}
            className="p-4 rounded-md bg-white border-primary300 border-[1px]"
          >
            <div className="text-dlg md:text-dxxl text-gray700">
              <Quote />
            </div>
            <div className="md:mt-4 W2STThin text-gray700 md:mb-10 text-tmd md:text-txl">
              {content}
            </div>
            <div className="flex mt-3 gap-3">
              {/* <Image
                src={TestAvatar2}
                alt="avatar"
                className="h-[50px] w-[50px]"
              /> */}
              <div>
                <div className="W2STMedium text-gray900 text-tmd md:text-txl">
                  {name}
                </div>
                <span className="text-gray700 text-tsm">Student</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StudentTestimonials;
